import connectNumericMenu from "instantsearch.js/es/connectors/numeric-menu/connectNumericMenu.js";
import { useConnector } from "../hooks/useConnector.js";
export function useNumericMenu(props, additionalWidgetProperties) {
  return useConnector(connectNumericMenu, props, additionalWidgetProperties);
}